export default __webpack_public_path__ + "fonts/Gotham-Medium.9b808b7447bef47aae61366e69f259b6.woff2";